/**
 * Relaties - Relaties overzicht
 * EXACT zoals Morris relaties.html
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BoekhoudingLayout from '../../components/boekhouding/BoekhoudingLayout';
import styles from '../../styles/Boekhouding.module.css';
import { boekhoudingService, Relatie } from '../../services/boekhouding.service';

const Relaties = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [relaties, setRelaties] = useState<Relatie[]>([]);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const result = await boekhoudingService.getRelaties();
        setRelaties(result.items);
      } catch (err) {
        console.error('Error loading relaties:', err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm('Relatie verwijderen?')) return;

    try {
      await boekhoudingService.deleteRelatie(id);
      setRelaties(relaties.filter(r => r.id !== id));
    } catch (err) {
      console.error('Error deleting relatie:', err);
      alert('Fout bij verwijderen');
    }
  };

  // Badge class mapping - EXACT Morris
  const getBadgeClass = (type: string): string => {
    switch (type) {
      case 'debiteur':
        return styles.badgeDebiteur;
      case 'crediteur':
        return styles.badgeCrediteur;
      case 'beide':
        return styles.badgeBeide;
      default:
        return '';
    }
  };

  // Type label - EXACT Morris
  const getTypeLabel = (type: string): string => {
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  const headerActions = (
    <button
      className={`${styles.btn} ${styles.btnPrimary}`}
      onClick={() => navigate('/boekhouding/relatie/nieuw')}
    >
      + Nieuwe Relatie
    </button>
  );

  if (loading) {
    return (
      <BoekhoudingLayout title="Relaties" headerActions={headerActions}>
        <div className={styles.loading}>Laden...</div>
      </BoekhoudingLayout>
    );
  }

  return (
    <BoekhoudingLayout title="Relaties" headerActions={headerActions}>
      <div className={styles.card}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Naam</th>
              <th>Type</th>
              <th>Adres</th>
              <th>Plaats</th>
              <th>Telefoon</th>
              <th style={{ width: '120px' }}>Acties</th>
            </tr>
          </thead>
          <tbody>
            {relaties.length === 0 ? (
              <tr>
                <td colSpan={6} className={styles.emptyState}>
                  Geen relaties gevonden
                </td>
              </tr>
            ) : (
              relaties.map((relatie) => (
                <tr key={relatie.id}>
                  <td><strong>{relatie.naam}</strong></td>
                  <td>
                    <span className={`${styles.badge} ${getBadgeClass(relatie.type)}`}>
                      {getTypeLabel(relatie.type)}
                    </span>
                  </td>
                  <td>{relatie.adres || '-'}</td>
                  <td>{relatie.plaats || '-'}</td>
                  <td>{relatie.telefoon || '-'}</td>
                  <td>
                    <button
                      className={`${styles.btn} ${styles.btnSmall} ${styles.btnSecondary}`}
                      onClick={() => navigate(`/boekhouding/relatie/${relatie.id}/bewerk`)}
                    >
                      Bewerk
                    </button>
                    <button
                      className={`${styles.btn} ${styles.btnSmall} ${styles.btnDanger}`}
                      onClick={() => handleDelete(relatie.id)}
                      style={{ marginLeft: '0.25rem' }}
                    >
                      X
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </BoekhoudingLayout>
  );
};

export default Relaties;
